import { z } from 'zod';

/**
 * Whether a framing panel receives wood finish, on how many faces, under which
 * profile, and how much harder than average it is to finish.
 *
 * Every field is defaulted and the object itself is defaulted, so a config
 * saved before this feature existed parses to "no finishing" and costs exactly
 * what it costed before.
 */
export const PanelFinishSchema = z.object({
  enabled: z.boolean().default(false),
  /** Faces that receive finish. Default 1 — one exposed face is the common case. */
  sides: z.union([z.literal(1), z.literal(2)]).default(1),
  /** null = inherit the template-level framing.default_finish_id. */
  finish_id: z.string().uuid().nullable().default(null),
  /**
   * Multiplier on this panel's contribution to the finishing complexity score,
   * for panels with more planing and cutting than average. Does NOT affect
   * material cost — a harder panel takes more time, not more lacquer.
   */
  complexity: z.number().min(0).default(1),
}).default({});

export type PanelFinish = z.infer<typeof PanelFinishSchema>;

/**
 * A panel that receives no finish. Use when constructing rails and panels in
 * client code, where the Zod defaults have not been applied yet.
 */
export const DEFAULT_PANEL_FINISH: PanelFinish = {
  enabled: false,
  sides: 1,
  finish_id: null,
  complexity: 1,
};
